import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { IAlerts } from './alert/alert.interface';

@Injectable()
export class AlertService {
    alerts = new Subject<Array<IAlerts>>();
    alerts$ = this.alerts;
    alertData: Array<IAlerts> = [];

    setAlert(alert: IAlerts): void {
        this.alertData.push(alert);
        this.alerts.next(this.alertData);
    }

    removeAlert(alert: IAlerts): void {
        alert.fadeOut = true;
        setTimeout(_ => {
            this.alertData = this.alertData.filter(al => al !== alert);
            this.alerts.next(this.alertData);
        }, 250);
    }
}
